import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function LatestArticles() {
  const latest = articles.slice(0, 3);

  return (
    <section className="py-20 md:py-28 px-6 bg-background-100">
      <div className="mx-auto" style={{ maxWidth: 1280 }}>
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              最新文章
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选内容推荐
            </h2>
          </div>
          <Link
            to="/category/resource-navigation"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                    {article.category.name}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {article.publishDate}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/resource-navigation"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部文章 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}